export default __webpack_public_path__ + "static/media/23-460x460.f2a22f80.jpeg";